export default function HeyLoyaltyCrossDomain() {
    const TRACKER = new CrossDomainTracker()
    TRACKER.init()
}

class CrossDomainTracker {
    init() {
        this.config = {
            billetDomain: 'billet.msj.dk',
            checkInterval: 100,
            maxAttempts: 50,
            debug: false
        }

        this.attempts = 0
        this.observer = null

        this.startTracking()
    }

    log(...args) {
        if (this.config.debug) {
            console.log('[HeyLoyalty Cross-Domain]', ...args)
        }
    }

    addTrackingParams(url, cookieId, sessionId) {
        try {
            const URL_OBJ = new URL(url, window.location.origin)

            if (!URL_OBJ.hostname.includes(this.config.billetDomain)) {
                return url
            }

            if (cookieId && !URL_OBJ.searchParams.has('hccookie')) {
                URL_OBJ.searchParams.set('hccookie', cookieId)
            }
            if (sessionId && !URL_OBJ.searchParams.has('hcsession')) {
                URL_OBJ.searchParams.set('hcsession', sessionId)
            }

            return URL_OBJ.toString()
        } catch (e) {
            this.log('Error parsing URL:', url, e)
            return url
        }
    }

    updateLinks() {
        if (typeof hlt === 'undefined' || !hlt.cookieId || !hlt.sessionId) {
            this.log('HeyLoyalty tracking not ready yet')
            return false
        }

        const COOKIE_ID = hlt.cookieId
        const SESSION_ID = hlt.sessionId

        this.log('HeyLoyalty cookies found:', { COOKIE_ID, SESSION_ID })

        const LINKS = document.querySelectorAll(`a[href*="${this.config.billetDomain}"]`)

        this.log(`Found ${LINKS.length} links to ${this.config.billetDomain}`)

        for (let i = 0; i < LINKS.length; i++) {
            const LINK = LINKS[i]
            const ORIGINAL_HREF = LINK.getAttribute('href')
            const UPDATED_HREF = this.addTrackingParams(ORIGINAL_HREF, COOKIE_ID, SESSION_ID)

            if (ORIGINAL_HREF !== UPDATED_HREF) {
                LINK.setAttribute('href', UPDATED_HREF)
                this.log('Updated link:', ORIGINAL_HREF, '->', UPDATED_HREF)
            }
        }

        return true
    }

    startTracking() {
        const CHECK_INTERVAL = setInterval(() => {
            this.attempts++

            if (this.updateLinks()) {
                clearInterval(CHECK_INTERVAL)
                this.log('Cross-domain tracking initialized successfully')
                this.observeDOMChanges()
            } else if (this.attempts >= this.config.maxAttempts) {
                clearInterval(CHECK_INTERVAL)
                console.warn('[HeyLoyalty Cross-Domain] Could not find HeyLoyalty tracking after', this.config.maxAttempts, 'attempts')
            }
        }, this.config.checkInterval)
    }

    observeDOMChanges() {
        if (typeof MutationObserver === 'undefined') {
            this.log('MutationObserver not supported')
            return
        }

        this.observer = new MutationObserver((mutations) => {
            let shouldUpdate = false

            for (let i = 0; i < mutations.length; i++) {
                const MUTATION = mutations[i]
                const ADDED_NODES = MUTATION.addedNodes

                for (let j = 0; j < ADDED_NODES.length; j++) {
                    const NODE = ADDED_NODES[j]

                    if (NODE.nodeType === 1) {
                        if (NODE.tagName === 'A' && NODE.href && NODE.href.includes(this.config.billetDomain)) {
                            shouldUpdate = true
                        } else if (NODE.querySelectorAll) {
                            const LINKS = NODE.querySelectorAll(`a[href*="${this.config.billetDomain}"]`)
                            if (LINKS.length > 0) {
                                shouldUpdate = true
                            }
                        }
                    }
                }
            }

            if (shouldUpdate) {
                this.log('New links detected, updating...')
                this.updateLinks()
            }
        })

        this.observer.observe(document.body, {
            childList: true,
            subtree: true
        })

        this.log('DOM observer activated')
    }
}